import { Injectable } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { PopulateFileMedia } from 'src/app/models/verylys/verylys';

@Injectable({
  providedIn: 'root'
})
export class VgImageService {
  private cache: Array<string | SafeResourceUrl | PopulateFileMedia> = [];
  constructor() { }

  public set(item: string | SafeResourceUrl | PopulateFileMedia): void {
    if (!item || this.cache.includes(item)) {
      return;
    }

    this.cache.push(item);
  }

  public has(item: string | SafeResourceUrl | PopulateFileMedia): boolean {
    return this.cache.includes(item);
  }
}
